import React from 'react';
import getStyles from './ProgressBar.style';
import { DISHOP_GREEN } from '../../constants';
import { useAppSelector } from '../../redux/hook';

export default function ProgressBar({ progress, isComplete = false, label }) {
  const { secondaryColor } = useAppSelector(
    (state) => state.configurationReducer
  );
  const value = `${isComplete ? 100 : Math.round(progress * 100)}%`;
  const displayText = label !== undefined ? label : value;
  const hasCustomLabel = label !== undefined;
  const style = getStyles()
  return (
    <div style={style.progressBarWrapper}>
      <div style={style.progressBarContainer}>
        <div
          style={{
            ...style.progressBar,
            width: value,
            backgroundColor: isComplete
              ? DISHOP_GREEN
              : secondaryColor ?? '#E6BD25',
          }}
        />
        <span style={style.progressText}>{value}</span>
      </div>
      {hasCustomLabel && (
        <div style={style.progressLabelBelow}>{displayText}</div>
      )}
    </div>
  );
}
